import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  background: linear-gradient(to right, #22D3EE, #8B5CF6, #22D3EE);
  background-size: 200% 100%;
  z-index: 999999;
  transition: width 0.08s linear;
  box-shadow: 0 0 8px rgba(34, 211, 238, 0.6);

  @media (hover: none) { display: none; }
`;

const ScrollProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const total   = document.documentElement.scrollHeight - window.innerHeight;
      setPct(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return <Bar style={{ width: `${pct}%` }} />;
};

export default ScrollProgress;
